import { createColumnHelper } from '@tanstack/react-table'
import { Flex } from '@chakra-ui/react'
import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'

const columnHelper = createColumnHelper()

const getALTableColumns = ({ handleActivate, handleDelete }) => {
  return [
    columnHelper.display({
      id: 'action',
      header: () => 'Action',
      size: 100,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ row: { original } }) => {
        const isActive = !original?.isDeleted
        return (
          <>
            {isActive && (
              <Flex _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="100%">
                <MdDeleteOutline
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDelete(original._id)
                  }}
                />
              </Flex>
            )}
            {!isActive && (
              <Flex _hover={{ cursor: 'pointer' }} color="green.400" justifyContent={'center'} w="100%">
                <MdOutlineCheckCircle
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleActivate(original._id)
                  }}
                />
              </Flex>
            )}
          </>
        )
      },
    }),
    columnHelper.accessor('country', {
      id: 'country',
      header: () => 'Country',
      cell: (info) => info.getValue(),
      enableColumnFilter: true,
      filterType: 'text',
    }),
    columnHelper.accessor('code', {
      id: 'code',
      header: () => 'Code',
      cell: (info) => info.getValue(),
      enableColumnFilter: true,
      filterType: 'text',
    }),
    columnHelper.accessor('description', {
      id: 'description',
      header: () => 'Description',
      cell: (info) => info.getValue(),
      enableColumnFilter: true,
      filterType: 'text',
    }),
    columnHelper.display({
      id: 'status',
      header: () => 'Status',
      accessorFn: (row) => (row.isDeleted ? 'Inactive' : 'Active'),
      cell: ({ row }) => {
        return row.original.isDeleted ? 'Inactive' : 'Active'
      },
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' },
        ],
      },
    }),
  ]
}

export default getALTableColumns
